import React from "react";

import AddIcon from "@mui/icons-material/Add";

import { ButtonVariant } from "Constant/button";

import { getSourceIconByCode } from "helpers/Sources/getSourceIcon";

import StandartButton from "components/atoms/StandartButton";

import SelectableList from "../../components/SelectableList";
import StepHeader from "../../components/StepHeader";
import { isSourceSelected } from "../../SignalWizard.helpers";
import { wizardButtonSx } from "../../SignalWizard.styled";

const getIcon = (source) => getSourceIconByCode(source?.source_type?.code);

const SourcesStep = ({
    language,
    isTemplateMode,
    sources,
    isSourcesLoading,
    selectedSources,
    onToggleSource,
    onDeleteSource,
    onAddSource,
}) => {
    const addLabel = language?.tracker_wizard?.add_source ?? "Add Source";

    return (
        <>
            <StepHeader
                language={language}
                stepNumber={1}
                title={
                    language?.tracker_wizard?.select_your_sources ??
                    "Select your sources"
                }
                description={
                    language?.tracker_wizard
                        ?.your_data_origin__where_customer_interactions_and_behaviors_are_captured_examples_include_websites_apps_or_crm_systems ??
                    "Your data origin - where customer interactions and behaviors are captured. Examples include websites, apps, or CRM systems."
                }
                helpText={
                    language?.tracker_wizard
                        ?.expand_your_data_collection_by_adding_multiple_sources_to_capture_a_broader_spectrum_of_customer_interactions ??
                    "Expand your data collection by adding multiple sources to capture a broader spectrum of customer interactions."
                }
                actionLabel={addLabel}
                onAction={onAddSource}
                actionTestId="create-source-add"
            />

            {!isTemplateMode && (
                <SelectableList
                    language={language}
                    items={sources}
                    typeKey="source_type"
                    getIcon={getIcon}
                    isSelected={(source) =>
                        isSourceSelected(selectedSources, source)
                    }
                    onToggle={onToggleSource}
                    onDelete={onDeleteSource}
                    inUseTooltip={
                        language?.tracker_wizard?.source_in_use ??
                        "Source is already in use!"
                    }
                    sectionTitle={
                        language?.tracker_wizard?.configured_sources ??
                        "Configured sources"
                    }
                    searchPlaceholder={
                        language?.tracker_wizard?.filter_sources ??
                        "Filter sources by name or type..."
                    }
                    emptyTitle={
                        language?.tracker_wizard?.no_sources_yet ??
                        "No sources yet"
                    }
                    emptyDescription={
                        language?.tracker_wizard?.create_first_source ??
                        "Create your first source to start collecting events."
                    }
                    emptyAction={
                        <StandartButton
                            variant={ButtonVariant.BLACK_OUTLINED}
                            onClick={onAddSource}
                            startIcon={<AddIcon />}
                            sx={wizardButtonSx}
                        >
                            {addLabel}
                        </StandartButton>
                    }
                    isLoading={isSourcesLoading}
                    itemTestId="wizard-source-item"
                />
            )}
        </>
    );
};

export default SourcesStep;
